import { render, staticRenderFns } from "./events-help.vue?vue&type=template&id=fc4e6f7a&scoped=true"
import script from "./events-help.vue?vue&type=script&lang=js"
export * from "./events-help.vue?vue&type=script&lang=js"
import style0 from "./events-help.vue?vue&type=style&index=0&id=fc4e6f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4e6f7a",
  null
  
)

export default component.exports